<template>
    <div id="cardBottom">
        <span class="isOverdue" v-if="data.status === 4 || data.status === 3">
            已失效
        </span>
        <span class="recommendText" v-if="data.accountName">
            <img :src="data.avatar" class="avatarImg" /><span
                class="accountInfo"
            >
                {{ data.accountName }} 推荐</span
            >
        </span>
    </div>
</template>
<script>
export default {
    name: "cardBottom",
    data() {
        return {};
    },
    props: {
        data: Object,
    },
};
</script>
<style lang="less" scoped>
#cardBottom {
    line-height: 24px;
    margin-top: 16px; /*px*/
    overflow: hidden;
    padding: 0 10px;
    .isOverdue {
        float: left;
        font-size: 24px !important; /*px*/
    }
    .recommendText {
        float: right;
        display: flex;
        justify-content: space-between;
        align-items: center;
        span {
            font-size: 24px !important; /*px*/
            font-family: PingFang SC;
            color: rgba(181, 181, 181, 1);
        }
        .avatarImg {
            width: 27px !important;
            height: 27px !important;
            display: inline-block;
            border-radius: 27px;
            margin: 0 8px 0 0;
        }
        .accountInfo {
            font-size: 24px;
            line-height: 21px;
        }
    }
}
</style>
